import Image from 'app/Components/Shared/Image/image';
import React, {useMemo, useEffect, useState} from 'react';
import {connect} from 'react-redux';
//store functions
import {setSearchingMode, setSelectedAbroadPackage, openModal, closeModal} from '../cellcomAbroadBlockSlice';

import {Container, Row, Col, Collapse} from 'reactstrap';
import {isMobileOnly as isMobile, isTablet} from 'react-device-detect';
import {popupReasonEnum, searchParametersEnum, lobbyTabsEnum} from '../cellcomAbroadVariables';
import {isSuitableDates} from '../cellcomAbroadUtilities';
import DatePickerComponent from '../DatePicker/DatePickerComponent';
import BtnRightSideText from '../../../Shared/Buttons/BtnRightSideText';
import LocalPopupContainer from '../LocalPopup/LocalPopupContainer';
import PopUp from '../../../Shared/Popup/PopUp';
import SelectedDatesAreNotSupportedInPackagePopupContent from '../Popups/SelectedDatesAreNotSupportedInPackagePopupContent';
import images from '../images/images';
import {gaSelectDatesTabIsClickedBusinessIndividual, gaSelectDatesTabIsClicked} from './../gaReports';
import {getDwhParams, dwhSetSelectedDates} from './../dwhReports';

const SelectDatesComponent = (props) => {
  //close popup from select countries item
  useEffect(() => {
    if (
      props.data.searchingMode.status &&
      props.data.searchingMode.searchParameter == searchParametersEnum.DATES &&
      (props.data.popupReason == 'connectedCountryExists' ||
        props.data.popupReason == 'selectedCountryIsNotSupportedInSelectedPackage' ||
        props.data.popupReason == 'allSelectedCountriesAreNotSupportedInSelectedPackage')
    ) {
      props.closeModal();
    }
  }, [props.data.searchingMode.status, props.data.searchingMode.searchParameter]);

  //popups mechanism
  const currentPopup = useMemo(() => {
    if (
      props.data.isShowPopup &&
      props.data.searchingMode.status &&
      props.data.searchingMode.searchParameter == searchParametersEnum.DATES &&
      props.data.popupReason != popupReasonEnum.OTP_RESULT &&
      props.data.popupReason != popupReasonEnum.COUNTRY_WARNING_INFO
    ) {
      return getCurrentPopupContent();
    }
  }, [props.data.isShowPopup, props.data.searchingMode.status, props.data.popupReason]);

  //DWH
  const [allowDWHReport, setAllowDWHReport] = useState(false);
  useEffect(() => {
    if (props.collapse) {
      setAllowDWHReport(true);
    } else {
      if (allowDWHReport && props.data.dates.selectedStartDate && props.data.dates.selectedEndDate) {
        const {channel, subscriber, param1, param4, param3, param5, param6, param7} = getDwhParams(props.data);
        dwhSetSelectedDates({channel, subscriber, param1, param4, param3, param5, param6, param7});
        setAllowDWHReport(false);
      }
    }
  }, [props.collapse]);

  function getCurrentPopupContent() {
    let popup;
    switch (props.data.popupReason) {
      case popupReasonEnum.SELECTED_DATES_ARE_NOT_SUITABLE_FOR_SELECTED_PACKAGE:
        popup = (
          <SelectedDatesAreNotSupportedInPackagePopupContent
            closeModal={() => props.closeModal()}
            selectedCountries={props.data.selectedCountries}
            packagePeriod={props.data.selectedAbroadPackage.packageDuration}
            packageDurationUnit={props.data.selectedAbroadPackage.packageDurationUnit}
            setSelectedAbroadPackage={(data) => props.setSelectedAbroadPackage(data)}
            getNextStep={(skipValidation) => getNextStep(skipValidation)}
            setSearchingMode={() => props.setSearchingMode()}
            dispatchSearching={() => props.dispatchSearching()}
            activeLobbyTab={props.data.activeLobbyTab}
            isSmallResolution={props.data.isSmallResolution}
            isPortrait={props.data.isPortrait}
            isSeparatedSale={props.data.otpData.validatedCostumerData?.isSeparatedSale}
          />
        );
        break;
    }
    return popup;
  }

  const validateIfAllowedAndOpen = () => {
    if (props.data.selectedAbroadPackage) {
      //check if selected package period is suitable
      const isSuitable = isSuitableDates(
        props.data.selectedAbroadPackage,
        props.data.dates.datePickerStartJSFormat,
        props.data.dates.datePickerEndJSFormat,
      );

      if (!isSuitable) {
        props.openModal(popupReasonEnum.SELECTED_DATES_ARE_NOT_SUITABLE_FOR_SELECTED_PACKAGE);
        return;
      }
    }
    getNextStep();
  };
  const getNextStep = (skipValidation = false) => {
    if (props.data.selectedCountries.length == 0) {
      props.closeModal();
      props.setSearchingMode(searchParametersEnum.COUNTRY);
    } else {
      if (!skipValidation) {
        props.setSearchingMode('');
      }

      props.validateAndStartSearching(null, null, skipValidation);
    }
  };
  const setSearchingMode = () => {
    if (props.data.epiStyleInitializationData.businessIndividualLobby) {
      gaSelectDatesTabIsClickedBusinessIndividual();
    } else {
      gaSelectDatesTabIsClicked(props.data.activeLobbyTab, props.data.otpData?.validatedCostumerData?.isSeparatedSale);
    }
    props.setSearchingMode(props.item.id);
  };

  const getDescriptionText = () => {
    let inputDate = new Date(props.data.dates?.datePickerStartJSFormat);
    let todaysDate = new Date();
    return inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0) ? null : `החבילה תיכנס לתוקף מחצות ביום הטיסה`;
  };

  return (
    <Col className={`${isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'col-12 p-0' : 'col-5'}`}>
      <div
        className={`${
          props.searchMode.status &&
          props.searchMode.searchParameter == searchParametersEnum.COUNTRY &&
          (isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution)
            ? 'pt-100'
            : 'bordered'
        } search-item-component ${props.collapse ? 'selecting-mode' : ''}`}
        onClick={() => (props.collapse ? null : setSearchingMode())}>
        <Container className={`search-item-component-wrapper ${props.selectedData ? 'selected-data-exists' : ''}`}>
          <Row>
            <Col className={`${props.collapse ? 'col-11 pl-0' : 'col-12'}`}>
              <span className='align-middle search-item-component-wrapper__icon'>
                <Image src={props.collapse ? props.item.activeIcon : props.item.icon} alt='icon' className='' />
              </span>
              <span
                className={`d-inline-block align-middle search-item-component-wrapper__title ${
                  props.collapse || props.selectedData ? 'data-exists' : 'bold'
                }`}>
                {props.item.title}
              </span>
            </Col>

            {props.collapse && (
              <Col className={`${props.collapse ? 'col-1' : ''} pr-0`}>
                <span
                  className={`align-middle search-item-component-wrapper__close`}
                  onClick={() => {
                    props.setSearchingMode('');
                  }}>
                  <Image src={images.close} alt='icon' />
                </span>
              </Col>
            )}
          </Row>

          {!props.collapse && props.selectedData && (
            <Row>
              <Col>
                <span
                  className='align-middle bold search-item-component-wrapper__selected-data'
                  dangerouslySetInnerHTML={{__html: props.selectedData}}
                />
              </Col>
            </Row>
          )}

          <Row>
            <Col>
              <span className='search-item-component-wrapper__description'>
                {props.selectedData || props.collapse ? getDescriptionText() : props.item.description}
              </span>
            </Col>
          </Row>

          <Row>
            <Collapse isOpen={props.collapse} className='w-100 col'>
              <Col className='select-dates-wrapper'>
                <Row>
                  <DatePickerComponent validateAndStartSearching={props.validateAndStartSearching} />
                </Row>
                <Row>
                  <Col className='p-0'>
                    <BtnRightSideText
                      onclick={() => validateIfAllowedAndOpen()}
                      isDisplayArrows={true}
                      text={'המשך'}
                      customClass='search-item-button'
                    />
                  </Col>
                </Row>
              </Col>
            </Collapse>
          </Row>
          {isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? (
            <PopUp
              className={props.data.popupReason}
              showPopUp={
                props.data.isShowPopup &&
                props.data.searchingMode.status &&
                props.data.searchingMode.searchParameter == searchParametersEnum.DATES &&
                props.data.popupReason != popupReasonEnum.OTP_RESULT
              }
              onClose={() => props.closeModal()}>
              {currentPopup}
            </PopUp>
          ) : (
            <LocalPopupContainer
              className={props.data.popupReason}
              showPopUp={
                props.data.isShowPopup &&
                props.data.searchingMode.status &&
                props.data.searchingMode.searchParameter == searchParametersEnum.DATES &&
                props.data.popupReason != popupReasonEnum.OTP_RESULT &&
                props.data.popupReason != popupReasonEnum.COUNTRY_WARNING_INFO
              }
              onClose={() => props.closeModal()}>
              {currentPopup}
            </LocalPopupContainer>
          )}
        </Container>
      </div>
    </Col>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
  };
};

const mapDispatchToProps = {
  setSearchingMode,
  setSelectedAbroadPackage,
  openModal,
  closeModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectDatesComponent);
